// extracted by mini-css-extract-plugin
module.exports = {"toaster":"styles_toaster__QvDJE","toaster__list":"styles_toaster__list__sIRzE"};